
import { defineComponent, ref } from 'vue'
import TreeOrgNode from '@/components/node'
import Tools from '@/components/tools'
import Draggable from '@/components/draggable'
import CloneOrg from '@/components/clone-org'
import Contextmenu from '@/components/contextmenu'
import drag from '@/directives/drag'
import { treeProps, treeEmits } from './tree'
import { useTree } from './use-tree'
export default defineComponent({
  name: 'vue3TreeOrg',
  components: {
    Tools,
    CloneOrg,
    Draggable,
    Contextmenu,
    TreeOrgNode
  },
  directives: {
    nodedrag: drag
  },
  props: treeProps,
  emits: treeEmits,
  setup (props, ctx) {
    const defaultSlot = !!ctx.slots.default
    const expandSlot = !!ctx.slots.expand
    const eleRef = ref<HTMLElement>()
    const treeRef = ref<HTMLElement>()
    const zoomRef = ref<HTMLElement>()
    const treeOrg = useTree(props, ctx, { eleRef, treeRef, zoomRef })
    return {
      eleRef,
      treeRef,
      zoomRef,
      defaultSlot,
      expandSlot,
      ...treeOrg
    }
  }
})
